import React from 'react';
import { Avatar, AvatarGroup, Grid, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, Icon, TagsArray, Text, useSettings } from 'app/main/components';
import buttons from './GroupsButtons';

export default function GroupsListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	const usersAvatarsBaseFolder = `${import.meta.env.VITE_ENDPOINT}/resources/users`;

	return (
		<GridListItem buttons={buttons.view?.itemButtons}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={props.width >= 960 ? 6 : 12}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.grps_warning_desc && (
								<Tooltip title={props.model.grps_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.grps_blocked_desc && (
								<Tooltip title={props.model.grps_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'groups', uid: props.model.grps_uid }}
							>
								{props.model.grps_title}
							</Text>
						</Grid>
						<Grid>
							{/* MANAGER */}
							<ButtonLink
								href={`/users/details/${props.model.user_manager_uid}`}
								icon="account-tie"
								fallback={t('VIEW_ITEM_NO_INTUSER')}
							>
								{props.model.user_manager_title}
							</ButtonLink>
						</Grid>
					</Grid>
				</Grid>
				{props.width >= 600 && (
					<Grid size={props.width >= 960 ? 3 : 6} className="flex">
						{/* USERS */}
						<AvatarGroup max={4}>
							{props.model.grps_users?.map((user, index) => (
								<Tooltip key={index} title={user.user_title || index} arrow>
									<Avatar
										src={
											user.user_avatar
												? `${usersAvatarsBaseFolder}/${user.user_uid}/${user.user_avatar}`
												: undefined
										}
									>
										{user.user_title_initials}
									</Avatar>
								</Tooltip>
							))}
						</AvatarGroup>
					</Grid>
				)}
				{props.width >= 960 && (
					<Grid size={3}>
						{/* TAGS */}
						<TagsArray tags={props.model.grps_tags} changeFilter={props.changeFilter} />
					</Grid>
				)}
			</Grid>
		</GridListItem>
	);
}
